/**
 * Set language
 * @param {*} payload 
 */
export const setLang = (payload) => ({ type: 'SET_LANGUAGE', payload })
